/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/bug
 */
import { default as DefaultIcon } from '~icons/lucide/bug';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const BugIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
